// TipoPillsXL - Sprint 44 Fase 3 Vista 10.
// Pills de tipo de importacion. Reusa XLChip para selectionables.
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';
import XLChip from '../../../components/xl/XLChip';
import { TIPOS } from '../utils';

const CSS_ID = 'xl-tipo-pills-css';
const CSS = `
.xl-tipos-card {
  background: var(--xl-color-surface);
  border: 1px solid var(--xl-color-border);
  border-radius: var(--xl-radius-lg);
  box-shadow: var(--xl-shadow-sm);
  padding: 14px 16px;
  font-family: var(--xl-font-sans);
}
.xl-tipos-card__title {
  font-size: 11px; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.06em;
  color: var(--xl-color-text-muted); margin-bottom: 10px;
}
.xl-tipos-card__list { display: flex; flex-wrap: wrap; gap: 6px }
.xl-tipos-card__icon {
  display: inline-block; margin-right: 4px; line-height: 1;
}
`;

export default function TipoPillsXL({ value, onChange }) {
  useEffect(() => { ensureKeyframes(); injectCSS(CSS_ID, CSS); }, []);
  return (
    <div className="xl-tipos-card">
      <div className="xl-tipos-card__title">Tipo de importacion</div>
      <div className="xl-tipos-card__list" role="tablist" aria-label="Tipo">
        {TIPOS.map((x) => (
          <XLChip
            key={x.k}
            onClick={() => onChange(x.k)}
            selected={value === x.k}>
            <span className="xl-tipos-card__icon" aria-hidden="true">{x.icon}</span>
            {x.label}
          </XLChip>
        ))}
      </div>
    </div>
  );
}
